angular.module('acme.common.service.refundsApi', [])
  .service('RefundsApiService', [ '$http', function ($http) {

    return {

      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/b2b/refunds';
        return this;
      },

      refund : function(refundObject) {
        return $http({
          method: 'post',
          url: this.service,
          data: refundObject
        });

      }
    };

  }]);